import { render, staticRenderFns } from "./SearchMatchRules.vue?vue&type=template&id=07ca3964&scoped=true"
import script from "./SearchMatchRules.vue?vue&type=script&lang=js"
export * from "./SearchMatchRules.vue?vue&type=script&lang=js"
import style0 from "./SearchMatchRules.vue?vue&type=style&index=0&id=07ca3964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ca3964",
  null
  
)

export default component.exports